import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { Device } from '../../devices.model_new';
import { SessionStateService } from '../../../../core/services/session-state.service';
import { SharedUtils } from '../../../../shared/shared.utils';
import { DeviceType, STATE_VAR } from '../../devices.constant';
import { IotService } from '../../../../core/services/iot.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-generation-detail',
  templateUrl: './generation-detail.component.html',
  styleUrls: ['./generation-detail.component.scss']
})
export class GenerationDetailComponent implements OnInit, OnDestroy {
loaded: boolean;
mode: string;
@Input()
device: Device;
DeviceType = DeviceType;
SharedUtils = SharedUtils;
realTimeSubscription: Subscription;

  constructor(private sessionSatesService: SessionStateService,
  private iotService: IotService) { }

  ngOnInit() {
    this.iotService.connect();
    this.obtainRealTimeResponses();
  }

  getLanguage() {
    return this.sessionSatesService.getLang();
  }

  private obtainCachedResponses(): void {
    this.iotService.responseHistory.forEach((message, moduleLocalId) => {
      this.processMessage(message);
    }
    );
  }

  private obtainRealTimeResponses(): void {
    this.obtainCachedResponses();
    if (this.iotService.messagesObserver) {
      this.realTimeSubscription = this.iotService.messagesObserver.subscribe(
        message => {
          this.processMessage(message);
        }
      );
    }
  }

  private processMessage(message: any): void {
    if (this.device !== undefined) {
      const platformKey = message.platformKey;
      if (message.moduleLocalId === this.device.getModuleLocalId()) {
        if (platformKey !== STATE_VAR.CONNECTIVITY_STATE) {
          const statVar = this.device.getStateVar(platformKey);
          if (statVar) {
            statVar.value = message.value;
          }
        } else {
          this.device.setConnectivityState(message.value);
        }
      }
    }
  }

  ngOnDestroy(): void {
    if(this.realTimeSubscription) {
      this.realTimeSubscription.unsubscribe();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/entities/devices/device-detail/generation-detail/generation-detail.component.ts